export default __webpack_public_path__ + "static/f445820111665499c56ab8a2a121b19b.png";